module.exports = __webpack_public_path__ + "img/partner_white@2x.cfb4f6de.png";